import { BaseModule } from '@mc/tangram-core'

export class PhaseOperations extends BaseModule {
  id = ''
  name = ''

  constructor(options) {
    super(options)

    const shouldBuildModule = true

    switch (Number(options.layoutType)) {
      case 1:
        this.name = 'phase_operations_complex'
        break
      case 2:
      case 3:
        this.name = 'phase_operations'
        break
      case 4:
        this.name = 'phase_operations_simple'
    }

    if (shouldBuildModule) {
      this.id = options.id
      this.layoutType = options.layoutType
      this.backgroundImage = options.style.bgImg
      this.backgroundColor = options.style.bgColor
      this.data = options.data
    } else {
      return {}
    }
  }

  render() {
    const {
      id,
      pageId,
      name,
      containerStyle,
      backgroundImage,
      data,
      objectValue,
      objectImg
    } = this
    return {
      id,
      pageId,
      renderIdentifier: name,
      containerStyle,
      backgroundImage,
      data,
      objectValue,
      objectImg
    }
  }
}
